import type {PanelBottomPill} from '@Components/panel/components/panel-bottom-pills';
import {PanelFooter, PanelFooterPrimaryDefaultAction} from '@Components/panel';
import type {ReactElement} from 'react';
import React from 'react';
import {getSelectedGridItems} from '@Components/base-grid';
import type {StockPrimaryCTA} from '@Panels/stock-panel/stock-panel.types';
import {StockPanelTabs, STOCK_PANEL_TAB_ID} from '@Panels/stock-panel/stock-panel.types';
import {getBottomPills} from '@Panels/stock-panel/stock-panel.library';
import {useSelectedTab} from '@Components/tabs';
import type {AiButtonProps} from '@Components/ai-button';
import {AiButton} from '@Components/ai-button';
import {useAppSelector} from '@/hooks';

export interface StockPanelFooterProps {
  selectionGroupID: string;
  bottomPillItems?: Array<PanelBottomPill>;
  onPrimaryAction: StockPrimaryCTA;
  makeBottomPillsScrollable: boolean;
  isMobile?: boolean;
  aiImageCTAProps?: AiButtonProps;
  tabId?: string;
}

const ALL_PILLS_LENGTH = getBottomPills(StockPanelTabs.ALL, () => {}).length;

export default function StockPanelFooter({isMobile = false, tabId = STOCK_PANEL_TAB_ID, ...props}: StockPanelFooterProps): ReactElement {
  const selectedItems = useAppSelector((state) => {
    return getSelectedGridItems(state, props.selectionGroupID);
  });
  const selectedTab = useSelectedTab(tabId, StockPanelTabs.TEXT_TO_IMAGE) as StockPanelTabs;

  const primaryAction = [
    <PanelFooterPrimaryDefaultAction
      key="stock-btn-cta-footer"
      text={window.i18next.t('pmwjs_add_selected')}
      onClick={(): void => {
        void props.onPrimaryAction(selectedItems);
      }}
    />,
  ];

  const getPrimaryAction = (): Array<ReactElement> | undefined => {
    if (selectedItems.length > 0) {
      return primaryAction;
    }

    if (isMobile && props.aiImageCTAProps && selectedTab === StockPanelTabs.TEXT_TO_IMAGE) {
      return [<AiButton {...props.aiImageCTAProps} isFullWidth key="ai-image-cta-footer" customClasses={`${props.aiImageCTAProps.customClasses} _full-width _full-height`} />];
    }

    return undefined;
  };

  return (
    <PanelFooter
      key={props.selectionGroupID}
      bottomPills={props.bottomPillItems}
      isScrollable={props.bottomPillItems && props.makeBottomPillsScrollable && props.bottomPillItems.length >= ALL_PILLS_LENGTH}
      className=""
      primaryActionsClassName=""
      primaryActions={getPrimaryAction()}
      border
      fullWidthPrimaryActions={isMobile}
    />
  );
}
